import React, { useEffect } from 'react';
import { Input } from '@cokitchen/cokitchen-components';
import useNewCareerPositionContext from 'contexts/career-position.context';
import Select from 'components/base/select';
import { departmentsInFc, experienceLevel, locationsInFc, workModeInFC } from './utils';

const CreateJobDetails = () => {
  const { setCreateJobPositionForm, createJobPositionForm, setDisabled } =
    useNewCareerPositionContext();

  useEffect(() => {
    const disabled = ![
      createJobPositionForm.jobTitle,
      createJobPositionForm.department,
      createJobPositionForm.workMode,
      createJobPositionForm.location,
      createJobPositionForm.experience
    ].every(Boolean);

    setDisabled(disabled);
  }, [createJobPositionForm]);

  return (
    <div className='space-y-4'>
      <Input
        type='text'
        label='Job title'
        placeholder='Enter job title'
        className='w-full mt-4'
        inputClass='px-4 py-3'
        value={createJobPositionForm.jobTitle}
        onChange={(e) =>
          setCreateJobPositionForm({ ...createJobPositionForm, jobTitle: e.target.value })
        }
      />

      <div className='mb-6'>
        <p className='text-sm font-medium mb-2'>Department/Team</p>
        <Select
          placeholder='Select department'
          value={createJobPositionForm.department}
          options={departmentsInFc.map((dept) => ({ value: dept, text: dept }))}
          onChange={(v) => setCreateJobPositionForm({ ...createJobPositionForm, department: v })}
        />
      </div>
      <div className='mb-6'>
        <p className='text-sm font-medium mb-2'>Work mode</p>
        <Select
          placeholder='Select work mode'
          value={createJobPositionForm.workMode}
          options={workModeInFC.map((mode) => ({ value: mode, text: mode }))}
          onChange={(v) => setCreateJobPositionForm({ ...createJobPositionForm, workMode: v })}
        />
      </div>
      <div className='mb-6'>
        <p className='text-sm font-medium mb-2'>Experience level</p>
        <Select
          placeholder='Select experience level'
          value={createJobPositionForm.experience}
          options={experienceLevel.map((mode) => ({ value: mode, text: mode }))}
          onChange={(v) => setCreateJobPositionForm({ ...createJobPositionForm, experience: v })}
        />
      </div>
      <div className='mb-6'>
        <p className='text-sm font-medium mb-2'>Location</p>
        <Select
          placeholder='Select location'
          value={createJobPositionForm.location}
          options={locationsInFc.map((location) => ({ value: location, text: location }))}
          onChange={(v) => setCreateJobPositionForm({ ...createJobPositionForm, location: v })}
        />
      </div>
    </div>
  );
};

export default CreateJobDetails;
